import * as React from 'react';

function SvgReconciliationScheduleIcon(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#reconciliation-schedule-icon_svg__clip0_1718_9160)">
        <path
          d="M15.429 2.854H12.57v-1a.143.143 0 00-.142-.143h-1a.143.143 0 00-.143.143v1H8.643v-1A.143.143 0 008.5 1.71h-1a.143.143 0 00-.143.143v1H4.714v-1a.143.143 0 00-.143-.143h-1a.143.143 0 00-.142.143v1H.57A.57.57 0 000 3.425v10.286a.57.57 0 00.571.571H15.43a.57.57 0 00.571-.571V3.425a.57.57 0 00-.571-.571zm-.715 10.143H1.286V4.14h2.143v1c0 .078.064.142.142.142h1a.143.143 0 00.143-.142v-1h2.643v1c0 .078.064.142.143.142h1a.143.143 0 00.143-.142v-1h2.643v1c0 .078.064.142.143.142h1a.143.143 0 00.142-.142v-1h2.143v8.857zM6.286 7.71H3a.143.143 0 00-.143.143v.857c0 .079.064.143.143.143h3.286a.143.143 0 00.143-.143v-.857a.143.143 0 00-.143-.143zm0 2.428H3a.143.143 0 00-.143.143v.857c0 .08.064.143.143.143h3.286a.143.143 0 00.143-.143v-.857a.143.143 0 00-.143-.143zm5.503-3.167L9.94 9.538l-.943-1.306a.282.282 0 00-.23-.117h-.98a.143.143 0 00-.116.226l2.037 2.825a.284.284 0 00.46 0l2.947-4.084a.143.143 0 00-.116-.226h-.98a.28.28 0 00-.229.116z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="reconciliation-schedule-icon_svg__clip0_1718_9160">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgReconciliationScheduleIcon;
